import { render, staticRenderFns } from "./StepBasicInfo.vue?vue&type=template&id=5fe10998"
import script from "./StepBasicInfo.vue?vue&type=script&lang=js"
export * from "./StepBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports